var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: { filterable: "", clearable: "", placeholder: "设备型号" },
              model: {
                value: _vm.searchData.code,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "code", $$v)
                },
                expression: "searchData.code"
              }
            },
            _vm._l(_vm.modelList, function(item, index) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.code }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: { clearable: "", placeholder: "请选择状态" },
              model: {
                value: _vm.searchData.status,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "status", $$v)
                },
                expression: "searchData.status"
              }
            },
            _vm._l(_vm.statusList, function(item, index) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.onClickSearch }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.onClickReset }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: {
                click: function($event) {
                  _vm.showAdd = true
                }
              }
            },
            [_vm._v("新增")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "100" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumn, function(item, index) {
            return [
              _c("el-table-column", {
                key: index,
                attrs: {
                  label: item.label,
                  formatter: item.formatter,
                  prop: item.prop
                }
              })
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "350" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to:
                            "/configure/configCondition/" +
                            scope.row.id +
                            "/" +
                            scope.row.code
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "success",
                              title: "编辑",
                              size: "mini"
                            }
                          },
                          [_vm._v("配置条件")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", title: "禁用", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.offShelfItem(scope.row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(scope.row.status == 1 ? "下架" : "上架"))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", title: "编辑", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.updateItem(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", title: "删除", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.delItem(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total > 0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showAdd,
            width: "500",
            title: _vm.configEdit ? "编辑推荐配置" : "新增推荐配置",
            closeable: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showAdd = $event
            },
            close: _vm.onAddDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "configForm",
              attrs: {
                rules: _vm.configFormRule,
                "label-width": "120",
                model: _vm.configForm
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择设备型号", prop: "model" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      attrs: {
                        disabled: _vm.configEdit,
                        clearable: "",
                        filterable: "",
                        placeholder: "设备型号"
                      },
                      on: { change: _vm.onCodeChange },
                      model: {
                        value: _vm.configForm.code,
                        callback: function($$v) {
                          _vm.$set(_vm.configForm, "code", $$v)
                        },
                        expression: "configForm.code"
                      }
                    },
                    _vm._l(_vm.modelList, function(item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.code + "/" + item.name,
                          value: item.code + "/" + item.name
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否上架", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.configForm.status,
                        callback: function($$v) {
                          _vm.$set(_vm.configForm, "status", $$v)
                        },
                        expression: "configForm.status"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入备注信息(非必填)",
                      type: "textarea"
                    },
                    model: {
                      value: _vm.configForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.configForm, "remark", $$v)
                      },
                      expression: "configForm.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSaveConfig }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }